import React from 'react';
import _ from 'lodash';

import { Input, Typography } from 'antd';

import { Form } from 'common/components';

import Messages from 'i18n/messages/apl';
import { useIntl } from 'react-intl';
import { validateEmail } from 'utils';

const { Text } = Typography;

let searchTimeout;

const AplSampleRequestEmailForm = (props) => {
  const intl = useIntl();

  const { form, contactEmail, setRequestSampleData } = props;

  const onValueChange = async (_fieldsChange, _allFieldsChange) => {
    const { email, emailTitle } = _allFieldsChange;

    const validEmail = validateEmail(email);

    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      setRequestSampleData((pre) => {
        const data = _.cloneDeep(pre);
        data[contactEmail].isValidEmail = !!emailTitle && validEmail;
        data[contactEmail].email = email;
        return data;
      });
    }, 200);
  };

  const layout = { labelCol: { span: 3 }, wrapperCol: { span: 21 } };

  return (
    <Form form={form} {...layout} onValuesChange={onValueChange}>
      <Form.Item
        name='email'
        label={intl.formatMessage(Messages.contactEmail)}
        rules={[
          {
            required: true,
            message: intl.formatMessage(Messages.emailRequired),
          },
          {
            type: 'email',
            message: intl.formatMessage(Messages.emailInvalid),
          },
        ]}
        style={{ height: 45, marginBottom: 0 }}
      >
        {contactEmail && contactEmail !== 'Empty' ? (
          <Text strong className='apl-request-sample__email'>
            {contactEmail}
          </Text>
        ) : (
          <Input />
        )}
      </Form.Item>
      <Form.Item
        name='emailTitle'
        label={intl.formatMessage(Messages.subject)}
        rules={[
          {
            required: true,
            message: intl.formatMessage(Messages.subjectRequired),
          },
        ]}
        style={{ height: 45, marginBottom: 0 }}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};

export default AplSampleRequestEmailForm;
